/* NBC Vol. 14 \u2014 "Peek inside" flipbook. Self-contained: window.NBCPeek.open(bookEl).
   The book flies out of bookEl, the cover swings open, pages flip on their own (arrows / swipe / \u2190\u2192 take over),
   and a buy card closes the run. All motion is JS-driven (requestAnimationFrame tweens). */
(() => {
  const CFG = window.NBC14 || {};
  const COVER = CFG.cover;
  const FALLBACK = CFG.pages || [];   // Steven 09-24: only 4 pages
  const BUY = CFG.cta || '/collections/no-bra-club-digital-edition';
  const FLIP_MS = 900, AUTO_MS = 2400;

  const css = `
  .nbcp-ov{position:fixed;inset:0;z-index:9999;font-family:futura-pt,'Jost','Futura','Century Gothic',sans-serif;color:#1a0a0e;-webkit-tap-highlight-color:transparent}
  .nbcp-ov *{box-sizing:border-box}
  .nbcp-bg{position:absolute;inset:0;background:radial-gradient(70% 60% at 50% 45%,rgba(255,224,232,.9),rgba(255,196,212,.86));backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);opacity:0}
  .nbcp-stage{position:absolute;inset:0;perspective:1800px;pointer-events:none}
  .nbcp-book{position:absolute;transform-style:preserve-3d;pointer-events:auto;touch-action:pan-y}
  .nbcp-leaf{position:absolute;top:0;height:100%;transform-style:preserve-3d;transform-origin:0 50%}
  .nbcp-face{position:absolute;inset:0;backface-visibility:hidden;-webkit-backface-visibility:hidden;background:#fff0f3 center/cover no-repeat;overflow:hidden;
    box-shadow:0 30px 60px -24px rgba(232,69,122,.55),0 8px 18px -8px rgba(26,10,14,.25)}
  .nbcp-face.front{border-radius:2px 6px 6px 2px}
  .nbcp-face.back{transform:rotateY(180deg);border-radius:6px 2px 2px 6px}
  .nbcp-face.front::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(90deg,rgba(26,10,14,.2),rgba(255,255,255,.12) 2%,rgba(255,255,255,0) 7%)}
  .nbcp-face.back::after{content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(270deg,rgba(26,10,14,.2),rgba(255,255,255,.12) 2%,rgba(255,255,255,0) 7%)}
  .nbcp-shade{position:absolute;inset:0;pointer-events:none;opacity:0;background:linear-gradient(90deg,rgba(26,10,14,.28),rgba(255,255,255,.18) 55%,rgba(26,10,14,.12))}
  .nbcp-panel{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;text-align:center;padding:10%;background:linear-gradient(160deg,#fff4f7,#ffd6e0)}
  .nbcp-mark{font:clamp(22px,4.2vw,40px)/.95 'Luckiest Guy','Arial Black',Impact,sans-serif;color:#FF97AD;-webkit-text-stroke:2px #fff;paint-order:stroke fill;text-shadow:0 0 12px rgba(255,151,173,.7),0 4px 0 #ffc9d5}
  .nbcp-sub{font:clamp(14px,1.8vw,19px)/1.1 'Bebas Neue','Oswald',sans-serif;letter-spacing:.14em;color:#e8457a}
  .nbcp-small{font:500 12px/1.4 futura-pt,'Jost',sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#6b4a53}
  .nbcp-btn{position:absolute;z-index:3;display:grid;place-items:center;width:48px;height:48px;border:0;border-radius:50%;background:#fff;color:#1a0a0e;
    font:600 22px/1 futura-pt,'Jost',sans-serif;cursor:pointer;box-shadow:0 8px 20px -6px rgba(232,69,122,.5);transition:transform .15s,background .15s}
  .nbcp-btn:hover{background:#FF97AD}
  .nbcp-btn:focus-visible,.nbcp-cta:focus-visible,.nbcp-again:focus-visible{outline:3px solid #e8457a;outline-offset:3px}
  .nbcp-x{top:calc(16px + env(safe-area-inset-top,0px));right:calc(16px + env(safe-area-inset-right,0px))}
  .nbcp-prev{left:max(16px,env(safe-area-inset-left,0px));top:50%;margin-top:-24px}
  .nbcp-next{right:max(16px,env(safe-area-inset-right,0px));top:50%;margin-top:-24px}
  .nbcp-ov.is-single .nbcp-prev,.nbcp-ov.is-single .nbcp-next{top:auto;margin-top:0;bottom:calc(18px + env(safe-area-inset-bottom,0px))}
  .nbcp-ov.is-single .nbcp-prev{left:calc(50% - 64px)}.nbcp-ov.is-single .nbcp-next{right:calc(50% - 64px)}
  .nbcp-count{position:absolute;left:50%;transform:translateX(-50%);bottom:calc(30px + env(safe-area-inset-bottom,0px));z-index:3;font:18px/1 'Bebas Neue',sans-serif;letter-spacing:.16em;color:#e8457a}
  .nbcp-ov.is-single .nbcp-count{bottom:calc(84px + env(safe-area-inset-bottom,0px))}
  .nbcp-end{position:absolute;left:50%;top:50%;z-index:4;width:min(92vw,440px);padding:30px 26px 26px;border-radius:24px;background:#fff;text-align:center;
    display:flex;flex-direction:column;align-items:center;gap:14px;box-shadow:0 30px 70px -24px rgba(232,69,122,.6);opacity:0;transform:translate(-50%,-46%) scale(.96);pointer-events:none}
  .nbcp-end.is-on{pointer-events:auto}
  .nbcp-end .nbcp-mark{font-size:clamp(30px,6vw,44px)}
  .nbcp-pills{display:flex;flex-wrap:wrap;justify-content:center;gap:8px}
  .nbcp-pills span{padding:9px 14px;border-radius:999px;background:#fff0f3;font:600 13px/1 futura-pt,'Jost',sans-serif;letter-spacing:.06em;color:#1a0a0e}
  .nbcp-pills b{font-weight:700;color:#e8457a}
  .nbcp-cta{display:inline-flex;align-items:center;justify-content:center;min-height:50px;width:100%;border-radius:999px;background:#FF97AD;color:#1a0a0e;text-decoration:none;
    font:700 13px/1 futura-pt,'Jost',sans-serif;letter-spacing:.22em;text-transform:uppercase;box-shadow:0 10px 26px rgba(255,151,173,.55)}
  .nbcp-again{border:0;background:none;font:600 12px/1 futura-pt,'Jost',sans-serif;letter-spacing:.18em;text-transform:uppercase;color:#6b4a53;text-decoration:underline;cursor:pointer;padding:6px}
  `;

  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const easeIO = x => x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  const easeOut = x => 1 - Math.pow(1 - x, 3);
  function tween(ms, fn, ease = easeIO) {
    return new Promise(res => {
      if (ms <= 0) { fn(1); res(); return; }
      const t0 = performance.now();
      const step = now => { const p = Math.min(1, (now - t0) / ms); fn(ease(p)); p < 1 ? requestAnimationFrame(step) : res(); };
      requestAnimationFrame(step);
    });
  }
  const lerp = (a, b, t) => a + (b - a) * t;
  function el(tag, cls, html) { const e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function preload(src) { return new Promise(r => { const i = new Image(); i.onload = i.onerror = () => r(); i.src = src; }); }

  let pagesP = null;
  function pages() {
    if (!pagesP) pagesP = Promise.resolve(FALLBACK);
    return pagesP;
  }

  let open_ = false;
  async function open(fromEl) {
    if (open_ || !fromEl) return; open_ = true;
    if (!document.getElementById('nbcp-style')) { const s = el('style'); s.id = 'nbcp-style'; s.textContent = css; document.head.appendChild(s); }
    const list = await pages();
    await Promise.race([Promise.all([COVER, ...list].map(preload)), new Promise(r => setTimeout(r, 2500))]);
    const RM = reduce();
    const single = innerWidth < 760;

    // ---------- build ----------
    const ov = el('div', 'nbcp-ov' + (single ? ' is-single' : ''));
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Peek inside No Bra Club Vol. 14');
    const bg = el('div', 'nbcp-bg'), stage = el('div', 'nbcp-stage'), book = el('div', 'nbcp-book');
    const bX = el('button', 'nbcp-btn nbcp-x', '&times;'), bP = el('button', 'nbcp-btn nbcp-prev', '&#8249;'), bN = el('button', 'nbcp-btn nbcp-next', '&#8250;');
    bX.setAttribute('aria-label', 'Close'); bP.setAttribute('aria-label', 'Previous page'); bN.setAttribute('aria-label', 'Next page');
    [bX, bP, bN].forEach(b => b.type = 'button');
    const count = el('div', 'nbcp-count'); count.setAttribute('aria-live', 'polite');
    const end = el('div', 'nbcp-end', `<div class="nbcp-mark">NO BRA CLUB<br>VOL. 14</div><div class="nbcp-sub">FT. HIEN HONEYBEE \u00b7 191 PAGES \u00b7 22 BTS CLIPS</div>
      <div class="nbcp-pills"><span>Own it forever \u00b7 <b>${CFG.own || '$179.99'}</b></span><span>Rent for 3 days \u00b7 <b>${CFG.rent || '$89.99'}</b></span></div>
      <a class="nbcp-cta" href="${BUY}">Join the Club</a><button type="button" class="nbcp-again">Read it again</button>`);
    stage.appendChild(book); ov.append(bg, stage, bP, bN, count, end, bX);

    const inside = `<div class="nbcp-mark">NO BRA CLUB</div><div class="nbcp-sub">VOL. 14 \u00b7 FT. HIEN HONEYBEE</div><div class="nbcp-small">Oiled up. Barely covered.<br>She texts you while you look.</div>`;
    const more = `<div class="nbcp-small">\u2026and that's just the start</div><div class="nbcp-mark">187 MORE<br>PAGES</div><div class="nbcp-sub">+ 22 BTS CLIPS</div>`;
    const back = `<div class="nbcp-mark" style="font-size:clamp(18px,3vw,28px)">ONLYLEWDS</div><div class="nbcp-small">art worth collecting</div>`;
    // faces: {img} or {html}
    const F = (x) => typeof x === 'string' ? { img: x } : x;
    let leaves;   // each: [front, back]
    if (single) leaves = [COVER, { html: inside }, ...list, { html: more }].map(f => [F(f), null]);
    else {
      const seq = [COVER, { html: inside }, ...list, { html: more }, { html: back }];
      leaves = []; for (let i = 0; i < seq.length; i += 2) leaves.push([F(seq[i]), F(seq[i + 1] || { html: back })]);
    }
    const N = leaves.length;
    const L = leaves.map(([fr, bk], i) => {
      const leaf = el('div', 'nbcp-leaf'), f = el('div', 'nbcp-face front' + (fr.html ? ' nbcp-panel' : '')), sh = el('div', 'nbcp-shade');
      if (fr.img) f.style.backgroundImage = `url("${fr.img}")`; else f.innerHTML = fr.html;
      f.appendChild(sh); leaf.appendChild(f);
      let b = null;
      if (bk) { b = el('div', 'nbcp-face back' + (bk.html ? ' nbcp-panel' : '')); if (bk.img) b.style.backgroundImage = `url("${bk.img}")`; else b.innerHTML = bk.html; b.appendChild(el('div', 'nbcp-shade')); leaf.appendChild(b); }
      book.appendChild(leaf);
      return { leaf, f, b, sh, deg: 0 };
    });

    // ---------- layout ----------
    let pw, ph, S = { tx: 0, ty: 0, s: 1, off: 0 }, k = 0;
    function layout() {
      const vw = innerWidth, vh = innerHeight;
      const room = single ? { w: vw * .84, h: vh - 190 } : { w: (vw - 170) / 2, h: vh * .8 };
      ph = Math.min(room.h, room.w / .75); pw = ph * .75;
      const bw = single ? pw : pw * 2;
      Object.assign(book.style, { width: bw + 'px', height: ph + 'px', left: (vw - bw) / 2 + 'px', top: (single ? (vh - 110 - ph) / 2 : (vh - ph) / 2) + 'px',
        transformOrigin: single ? '50% 50%' : '75% 50%' });
      L.forEach(o => Object.assign(o.leaf.style, { left: single ? '0' : pw + 'px', width: pw + 'px' }));
    }
    const offFor = kk => single ? 0 : kk === 0 ? -pw / 2 : kk >= N ? pw / 2 : 0;
    function applyBook() { book.style.transform = `translate(${S.tx}px,${S.ty}px) translateX(${S.off}px) scale(${S.s})`; }
    function applyLeaf(o, i) {
      o.leaf.style.transform = `rotateY(${o.deg}deg)`;
      const turning = o.deg < -1 && o.deg > -179;
      o.leaf.style.zIndex = turning ? N + 5 : (o.deg <= -90 ? i + 1 : N - i);
      const a = Math.sin(Math.abs(o.deg) * Math.PI / 180) * .9;
      o.sh.style.opacity = a; if (o.b) o.b.lastChild.style.opacity = a;
      if (single) o.leaf.style.opacity = o.deg <= -90 ? Math.max(0, 1 - (-o.deg - 90) / 20) : 1;
    }
    function fromGeom() {
      const r = fromEl.getBoundingClientRect(), br = book.getBoundingClientRect(); // br measured with identity transform
      const ox = parseFloat(book.style.left) + (single ? pw / 2 : pw * 1.5), oy = parseFloat(book.style.top) + ph / 2;
      return { tx: r.left + r.width / 2 - (ox + offFor(0)), ty: r.top + r.height / 2 - oy, s: r.width / pw };
    }
    function countTxt() {
      const total = single ? N : N;
      count.textContent = k === 0 ? 'THE COVER' : k >= N ? 'THE END?' : (single ? `PAGE ${k} / ${N - 1}` : `SPREAD ${k} / ${N - 1}`);
    }

    // ---------- flip engine ----------
    let busy = false, auto = null, closed = false;
    async function flipTo(target, ms = FLIP_MS) {
      target = Math.max(0, Math.min(N, target));
      if (busy || target === k) return; busy = true;
      hideEnd();
      while (k !== target && !closed) {
        const dir = target > k ? 1 : -1, i = dir > 0 ? k : k - 1, o = L[i];
        const d0 = o.deg, d1 = dir > 0 ? -180 : 0, off0 = S.off, off1 = offFor(k + dir);
        const dur = RM ? 0 : (Math.abs(target - k) > 1 ? ms * .55 : ms);
        if (RM) { book.style.opacity = 0; }
        await tween(dur, t => { o.deg = lerp(d0, d1, t); S.off = lerp(off0, off1, t); applyLeaf(o, i); applyBook(); });
        o.deg = d1; applyLeaf(o, i); k += dir; countTxt();
        if (RM) await tween(220, t => book.style.opacity = t, easeOut);
      }
      busy = false;
      if (k >= N) showEnd();
    }
    function startAuto() { stopAuto(); auto = setInterval(() => { if (busy) return; if (k >= N) { stopAuto(); return; } flipTo(k + 1); }, AUTO_MS); }
    function stopAuto() { if (auto) clearInterval(auto); auto = null; }
    function user(fn) { stopAuto(); fn(); }
    async function showEnd() { if (closed) return; end.classList.add('is-on'); await tween(RM ? 0 : 420, t => { end.style.opacity = t; end.style.transform = `translate(-50%,${lerp(-46, -50, t)}%) scale(${lerp(.96, 1, t)})`; book.style.opacity = lerp(1, .22, t); }, easeOut); end.querySelector('.nbcp-cta').focus({ preventScroll: true }); }
    function hideEnd() { if (!end.classList.contains('is-on')) return; end.classList.remove('is-on'); end.style.opacity = 0; book.style.opacity = 1; }

    // ---------- open ----------
    const prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(ov);
    layout(); L.forEach(applyLeaf); countTxt();
    const g0 = fromGeom();
    S = { ...g0, off: offFor(0) }; applyBook();
    fromEl.style.visibility = 'hidden';
    await tween(RM ? 0 : 520, t => { S.tx = lerp(g0.tx, 0, t); S.ty = lerp(g0.ty, 0, t); S.s = lerp(g0.s, 1, t); applyBook(); bg.style.opacity = t; }, easeOut);
    bg.style.opacity = 1; bX.focus({ preventScroll: true });
    setTimeout(async () => { if (closed) return; await flipTo(1); startAuto(); }, RM ? 0 : 250);

    // ---------- controls ----------
    bN.onclick = () => user(() => flipTo(k + 1));
    bP.onclick = () => user(() => flipTo(k - 1));
    end.querySelector('.nbcp-again').onclick = async () => { stopAuto(); hideEnd(); await flipTo(0, 420); await flipTo(1); startAuto(); };
    bX.onclick = close;
    ov.addEventListener('click', e => { if (e.target === ov || e.target === bg || e.target === stage) close(); });
    let sx = null;
    book.addEventListener('pointerdown', e => { sx = e.clientX; });
    book.addEventListener('pointerup', e => { if (sx == null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) user(() => flipTo(k + (dx < 0 ? 1 : -1))); else if (!busy) user(() => flipTo(k + 1)); });
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); user(() => flipTo(k + 1)); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); user(() => flipTo(k - 1)); }
      else if (e.key === 'Tab') {   // focus trap
        const fs = [...ov.querySelectorAll('button,a[href]')].filter(x => x.offsetParent !== null && getComputedStyle(x).visibility !== 'hidden' && (x.closest('.nbcp-end') ? end.classList.contains('is-on') : true));
        if (!fs.length) return; const i = fs.indexOf(document.activeElement);
        if (e.shiftKey && (i <= 0)) { e.preventDefault(); fs[fs.length - 1].focus(); } else if (!e.shiftKey && i === fs.length - 1) { e.preventDefault(); fs[0].focus(); }
      }
    }
    document.addEventListener('keydown', onKey);
    const onResize = () => { layout(); S.off = offFor(k); applyBook(); };
    addEventListener('resize', onResize);

    // ---------- close ----------
    async function close() {
      if (closed) return; closed = true; stopAuto();
      document.removeEventListener('keydown', onKey); removeEventListener('resize', onResize);
      end.style.opacity = 0; end.classList.remove('is-on'); book.style.opacity = 1;
      while (busy) await new Promise(r => setTimeout(r, 30));
      // fold every open leaf shut at once
      const open = L.map((o, i) => [o, i, o.deg]).filter(x => x[2] !== 0), off0 = S.off;
      await tween(RM ? 0 : 380, t => { open.forEach(([o, i, d]) => { o.deg = lerp(d, 0, t); applyLeaf(o, i); }); S.off = lerp(off0, offFor(0), t); applyBook(); });
      k = 0;
      const g = fromGeom();
      await tween(RM ? 0 : 460, t => { S.tx = lerp(0, g.tx, t); S.ty = lerp(0, g.ty, t); S.s = lerp(1, g.s, t); applyBook(); bg.style.opacity = 1 - t; });
      fromEl.style.visibility = '';
      ov.remove(); document.documentElement.style.overflow = prevOverflow; open_ = false;
      try { fromEl.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  window.NBCPeek = { open };
})();
